module.exports = __webpack_public_path__ + "static/media/share_facebook.700654b2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/share_facebook.svg
 ** module id = 475
 ** module chunks = 0
 **/